module.exports = __webpack_public_path__ + "screen2.png?49e9d75c14fc7b3838740c12138eb2c2";